import {
  alpha,
  Box,
  CssBaseline,
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Header from "./Header/Header";
import Navbar from "./Navbar/Navbar";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";
import { drawerWidth } from "../../constants/Constants";
import { useCallback, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { getCookie } from "../../utils/Utility";
import { LogoutOutlined } from "@mui/icons-material";
import { adminLogout } from "../Login/adminAuthActions";

const HeaderandNavbar = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const theme = useTheme();
  const authenticated = getCookie("authenticated");
  const roleCode = getCookie("roleCode");
  const isPasswordExpired = getCookie("isPasswordExpired") === "true";

  const dispatch = useAppDispatch();

  const { uiSettings } = useAppSelector((state: RootState) => state.uiSettings);
 
  const [pageName, setPageName] = useState("Dashboard");
  const [open, setOpen] = useState(false);
  const handleLogout = useCallback(() => {
    const date = new Date().toString();
    const logoutRequestBody = {
      logoutTime: date,
    };
    dispatch(adminLogout(logoutRequestBody));
  }, [dispatch]);

  const handleDrawerToggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  if (!authenticated || roleCode !== "1" || isPasswordExpired) return null;

  return (
    <>
      <CssBaseline />
      <Header position="fixed" open={open} drawerwidth={drawerWidth}>
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: isMobile ? 0 : "16px",
          }}
          id="admin_toolbar"
          data-test-id="admin_toolbar"
          aria-label="Admin Navigation Toolbar"
        >
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 5 }}
            id="admin_header_left"
            data-test-id="admin_header_left"
            aria-label="Admin Header Left Section"
          >
            {!isMobile && uiSettings?.logo && (
              <Box
                sx={{ height: "40px" }}
                id="admin_logo_container"
                data-test-id="admin_logo_container"
                aria-label="Admin Logo"
              >
                <img
                  src={`data:image/png;base64,${uiSettings?.logo}`}
                  alt="Admin Portal Logo"
                  style={{
                    height: "100%",
                    objectFit: "contain",
                  }}
                  id="admin_logo"
                  data-test-id="admin_logo"
                />
              </Box>
            )}
            <Box
              sx={{ display: "flex", alignItems: "center" }}
              id="admin_menu_button_container"
              data-test-id="admin_menu_button_container"
              aria-label="Menu Button Container"
            >
              <IconButton
                color="inherit"
                aria-label={
                  open ? "Close navigation menu" : "Open navigation menu"
                }
                onClick={handleDrawerToggle}
                edge="start"
                disableRipple
                id="admin_menu_button"
                data-test-id="admin_menu_button"
                sx={{
                  marginLeft: isMobile ? 1 : 5,
                  backgroundColor: open
                    ? alpha(theme.palette.primary.main, 0.08)
                    : "unset",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: alpha(theme.palette.primary.main, 0.15),
                  },
                }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center" }}
            id="admin_header_right"
            data-test-id="admin_header_right"
            aria-label="Admin Header Right Section"
          >
            <IconButton
              color="inherit"
              aria-label="Logout from admin portal"
              onClick={handleLogout}
              id="admin_logout_button"
              data-test-id="admin_logout_button"
            >
              <LogoutOutlined />
            </IconButton>
          </Box>
        </Toolbar>
      </Header>
      <Navbar
        open={open}
        setPageName={setPageName}
        drawerWidth={drawerWidth}
        setOpen={setOpen}
      />
    </>
  );
};

export default HeaderandNavbar;
